<header class="mobile-header" [attr.data-profile]="profile">
  <!-- Logo -->
  <div class="mobile-header-logo">
    <svg
      width="77"
      height="30"
      viewBox="0 0 77 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Huro"
    >
      <g clip-path="url(#clip0_mobile_header)">
        <path
          d="M18.8035 10.4449C20.4547 12.0133 21.2635 14.3493 21.2635 17.4527V18.2202H16.2088V18.0868C16.2088 16.218 15.7707 14.8165 14.8608 13.8487C13.9847 12.9144 12.7042 12.4138 11.053 12.4138C9.19961 12.4138 7.71681 12.9811 6.63851 14.0823C5.56021 15.1835 5.021 16.7853 5.021 18.8543V29.6663H0V0H5.0547V10.812C5.8972 9.94438 6.9081 9.24361 8.1549 8.77642C9.3681 8.30923 10.7497 8.07564 12.2661 8.07564C14.9956 8.07564 17.186 8.87653 18.8035 10.4449Z"
          fill="white"
        />
        <path
          d="M37.2703 8.34277V29.7332H32.4514V26.9968C31.6427 27.9646 30.6317 28.6987 29.4186 29.2327C28.2055 29.7666 26.8913 30.0002 25.5096 30.0002C22.6116 30.0002 20.3538 29.1993 18.7026 27.6309C17.0514 26.0625 16.209 23.6932 16.209 20.5563V19.622H21.2637V19.8556C21.2637 21.791 21.7018 23.226 22.5779 24.1603C23.4541 25.0947 24.7009 25.5953 26.3184 25.5953C28.1381 25.5953 29.5534 25.028 30.6317 23.9268C31.7101 22.8255 32.2156 21.2238 32.2156 19.1548V8.34277H37.2703Z"
          fill="white"
        />
        <path
          d="M52.9395 8.07568V12.8477C52.5014 12.7809 52.1307 12.7142 51.76 12.7142C49.8056 12.7142 48.2554 13.2815 47.1434 14.4161C46.0314 15.5507 45.4922 17.1858 45.4922 19.3215V29.6997H40.4375V8.34265H45.2563V11.4795C46.7053 9.24365 49.2664 8.10905 52.9395 8.10905V8.07568Z"
          fill="white"
        />
        <path
          d="M59.5782 28.5983C57.8259 27.6639 56.4443 26.3625 55.4671 24.694C54.4898 23.0255 53.9844 21.1233 53.9844 19.021C53.9844 16.9187 54.4898 15.0166 55.4671 13.3814C56.4443 11.7129 57.8259 10.4448 59.5782 9.51044C61.3305 8.57607 63.285 8.10889 65.4754 8.10889C67.6658 8.10889 69.654 8.57607 71.4063 9.51044C73.1586 10.4448 74.5402 11.7463 75.5174 13.3814C76.4947 15.0499 77.0001 16.9187 77.0001 19.021C77.0001 21.1233 76.4947 23.0255 75.5174 24.694C74.5402 26.3625 73.1586 27.6639 71.4063 28.5983C69.654 29.5327 67.6658 29.9999 65.4754 29.9999C63.285 29.9999 61.3305 29.5327 59.5782 28.5983ZM70.092 23.8597C71.3052 22.625 71.9117 21.0232 71.9117 19.021C71.9117 17.0188 71.3052 15.417 70.092 14.1823C68.8789 12.9476 67.3288 12.3469 65.4754 12.3469C63.622 12.3469 62.0719 12.9476 60.8925 14.1823C59.6793 15.417 59.1065 17.0188 59.1065 19.021C59.1065 21.0232 59.713 22.625 60.8925 23.8597C62.1056 25.0944 63.622 25.6951 65.4754 25.6951C67.3288 25.6951 68.8789 25.0944 70.092 23.8597Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_mobile_header">
          <rect width="77" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>

  <!-- Action Icons -->
  <div class="mobile-header-actions">
    <!-- Notification Bell (optional) -->

    <umss-icon-button
      *ngIf="showNotifications"
      type="button"
      iconName="phosphorBell"
      iconSize="24px"
      iconColor="var(--white)"
      (click)="onNotificationClick()"
      variant="Ghost"
      aria-label="Notifications"
    >
    </umss-icon-button>

    <!-- Hamburger Menu Button -->

    <umss-icon-button
      *ngIf="showNotifications"
      type="button"
      iconName="phosphorList"
      iconColor="var(--white)"
      iconSize="24px"
      (click)="onMenuClick()"
      variant="Ghost"
      aria-label="Toggle menu"
    ></umss-icon-button>
  </div>
</header>
